import { isValidElement, ReactNode } from 'react';
import { renderChildren } from '@fiverr-private/ui_utils';
import { TabProps } from '../types';

export const renderTabChild =
    ({ isLink }: Pick<TabProps, 'isLink'>) =>
    (child: ReactNode) => {
        if (isLink && isValidElement(child)) {
            return renderChildren(child, { tabIndex: -1 });
        }
        return child;
    };
